module.exports = __webpack_public_path__ + "img/3dd2cE-4kJbJ9-79ZjO6ox.2166c853.svg";